import React, { useState, useEffect, useRef } from 'react';
import './SortFilter.scss';

const sort = (props, selectedOption) => {
  const { categoryActions, categoryId, location, order } = props;
  const originalHash = window.location.hash;
  const searchParams = new URLSearchParams(originalHash.substring(1));

  let modifiedLocation = '';

  if (location.hash.includes('dir')) {
    let loc = null;
    if (location.hash.split('dir')[0].length > 0) {
      loc = location.hash.slice(
        location.hash.lastIndexOf('dir') - 1,
        location.hash.lastIndexOf('true') + 4
      );
    } else {
      loc = location.hash.slice(
        location.hash.lastIndexOf('dir'),
        location.hash.lastIndexOf('true') + 4
      );
    }
    location.hash.split(loc).forEach(value => {
      modifiedLocation += value;
    });
  } else {
    modifiedLocation = location.hash;
  }

  if (!location.hash.includes('dir') && location.hash.includes('&gan_data=true')) {
    modifiedLocation = modifiedLocation.replace('&gan_data=true', '');
  }

  if (window.dtm.LenskartRewamp) {
    window.dtm.LenskartRewamp.Listing.sort.applySortingOnProduct(selectedOption);
  }

  const pageParam = searchParams.get('page');

  searchParams.delete('dir');
  searchParams.delete('sort');
  searchParams.delete('gan_data');

  searchParams.set('dir', order);
  searchParams.set('sort', selectedOption);
  searchParams.set('gan_data', 'true');

  if (!modifiedLocation.includes('#') && pageParam !== null) {
    searchParams.set('page', pageParam);
  }

  const tempSearchParams = new URLSearchParams();

  searchParams.forEach((value, key) => {
    if (key !== 'dir' && key !== 'sort' && key !== 'gan_data')
      tempSearchParams.set(`filter_${key}`, value);
    else tempSearchParams.set(key, value);
  });

  searchParams.delete('page');
  const tempString = searchParams.toString();

  if (modifiedLocation.includes('#')) {
    modifiedLocation = modifiedLocation.split('#')[0];
  }
  modifiedLocation += `#${tempString}`;

  const temp = {
    location,
    order: selectedOption,
  };

  const basePath = '/sg/en';
  const fullPath = `${basePath}${location.pathname}`;

  if (!modifiedLocation.includes('#')) {
    history.pushState('', '', `${fullPath}#${tempString}`);
    temp.location.hash = `#${modifiedLocation}`;
  } else {
    history.pushState('', '', `${fullPath}${modifiedLocation}`);
    temp.location.hash = modifiedLocation;
  }

  window.scrollTo(0, 0);
  categoryActions.modifyData(temp);
  categoryActions.getCategoryData(categoryId, `#${tempSearchParams.toString()}`, 0);
};

const SortFilter = props => {
  const { dataLocale, sortFilterValue = 'best_sellers' } = props;

  const {
    // BIGGEST_SAVING,
    MOST_VIEWED,
    NEW,
    PRICE_HIGH_TO_LOW,
    PRICE_LOW_TO_HIGH,
    BEST_SELLERS,
    SORT,
  } = dataLocale;

  const SORT_OPTIONS = [
    {
      name: 'best_sellers',
      title: BEST_SELLERS,
    },
    {
      name: 'low_price',
      title: PRICE_LOW_TO_HIGH,
    },
    {
      name: 'high_price',
      title: PRICE_HIGH_TO_LOW,
    },
    {
      name: 'created',
      title: NEW,
    },
    // {
    //   name: 'saving',
    //   title: BIGGEST_SAVING,
    // },
    {
      name: 'popular',
      title: MOST_VIEWED,
    },
  ];
  const currentSortOption = SORT_OPTIONS.find(({ name }) => name === sortFilterValue);
  const [showOptions, setShowOptions] = useState(false);
  const togglerInputRef = useRef(null);

  useEffect(() => {
    const path = window.location.pathname;
    const currentHash = window.location.hash;
    
    if (path.includes('newarrival') && !currentHash) {
      window.location.href = `${path}#dir=desc&sort=created&gan_data=true`;
    }
  }, []);

  const handleToggle = e => {
    e.target.focus();
    setShowOptions(!showOptions);
  };

  const handleBlur = e => {
    // firefox onBlur issue workaround
    if (
      e.nativeEvent.explicitOriginalTarget &&
      e.nativeEvent.explicitOriginalTarget === e.nativeEvent.originalTarget
    ) {
      return;
    }

    if (showOptions) {
      setTimeout(() => {
        setShowOptions(false);
      }, 200);
    }
  };

  if (location?.search?.length > 0) {
    return null;
  }

  return (
    <div className="sort-filter-wrapper">
      <label className="sort-filter-toggler">
        <input
          ref={togglerInputRef}
          className="sort-filter-toggler__input od-font-bold"
          type="button"
          value={currentSortOption ? currentSortOption.title : SORT}
          onBlur={handleBlur}
          onClick={handleToggle}
        />
        <i
          className={`fa fa-angle-down sort-filter-toggler__icon${
            showOptions ? ' sort-filter-toggler__icon--active' : ''
          }`}
        />
      </label>
      {showOptions && (
        <div className="sort-filter-options">
          {SORT_OPTIONS.map(({ name, title }) => (
            <div
              key={name}
              className="sort-filter-options__option od-font-bold"
              onClick={() => sort(props, name)}
            >
              {title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortFilter;
